var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportstarLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.7,
    height: 100.2,
    viewBox: "0 0 154.7 100.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ecff19;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.7 34.8 115 34.8 104 .8 92.9 34.8 57.2 34.8 52.4 34.8 52 36.3 50.8 34.8 42.1 34.8 37.9 37.8 35.2 34.8 22.4 34.8 21.8 36.8 20.1 34.8 11.9 34.8 5.9 39.3 3.3 49.1 5.4 51.7 2.6 51.7 2.1 53.7 .5 59.6 5 65.2 13.7 65.2 14.5 64.6 14.4 65.2 17.9 65.2 25.2 65.2 27.5 56.8 30.4 56.8 31.5 56 30.6 59.6 31.5 60.7 35.1 65.2 43.8 65.2 44.5 64.6 44.4 65.2 47.9 65.2 53 65.2 62.7 65.2 63.9 65.2 66.2 65.2 73.6 65.2 74.9 60.4 78.7 65.1 83 65.1 75 89.7 104 68.7 132.9 89.7 121.8 55.8 150.7 34.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.3 47.6 11.8 47.2 13.1 42.2 16.6 42.2 15.7 45.6 20.4 45.6 21.6 40.9 18.8 37.5 12.8 37.5 8.3 40.9 6.3 48.5 9.3 52.1 13.8 52.5 12.5 57.7 9.1 57.7 9.9 54.4 4.7 54.4 3.5 59 6.3 62.4 12.8 62.4 17.4 59 19.4 51.3 16.3 47.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.9,37.5h-9.5l-6.6,24.9h5.2l2.2-8.4h4.2l4.9-3.5,2.5-9.6-3.1-3.4h0ZM29.6,49.3h-3l1.9-7h3l-1.9,7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.5,37.5h-6.5l-4.6,3.4-4.8,18,2.8,3.4h6.5l4.6-3.4,4.8-18s-2.8-3.4-2.8-3.4ZM46.7,42.2l-4.1,15.4h-3.4l4.1-15.4h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.1,40.8l-2.7-3.3h-9.9l-6.6,24.9h5.2l2.7-10.2h3.4l-2.7,10.2h5.2l2.7-10.2-2.5-2.4,3.4-2.5,1.7-6.5h0ZM60.5,47.6h-3.4l1.4-5.3h3.4l-1.4,5.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.7 37.5 69.1 37.5 67.9 42.2 71.6 42.2 66.2 62.4 71.5 62.4 76.8 42.2 80.5 42.2 81.7 37.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.2 51.3 90.1 47.6 85.6 47.2 86.9 42.2 90.3 42.2 89.4 45.6 94.2 45.6 95.4 40.9 92.6 37.5 86.6 37.5 82 40.9 80.1 48.5 83.1 52.1 87.6 52.5 86.2 57.7 82.8 57.7 83.7 54.4 78.5 54.4 77.3 59 80 62.4 86.6 62.4 91.1 59 93.2 51.3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportstarLogo);
export default __webpack_public_path__ + "static/media/sportstar-logo.8a7cdd5b72528653b489813ed341d7c9.svg";
export { ForwardRef as ReactComponent };